// extracted by mini-css-extract-plugin
export default {"verifiedContainer":"Verified_verifiedContainer__3aWNX","contentWrapper":"Verified_contentWrapper__XUnDe","verifiedContent":"Verified_verifiedContent__Y79D1"};